export class ListGoogleWorkspaceGroups200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<GoogleWorkspaceGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceGroups200Response.attributeTypeMap;
    }
    constructor() {
    }
}
